module.exports = __webpack_public_path__ + "img/bn2.8a67bdfe.png";